import React from "react";
import './assets/index.scss';

const Logo = () => {

    return (
        <div className="logo">
            <p className="logo__text"><span className="logo__text-accent">tracks</span>lyn</p>
        </div>
    )
}

export default Logo;